
import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';

class Crm extends React.Component
{
    constructor(props) {
        super(props);
        this.search = this.search.bind(this);
        this.renderResults = this.renderResults.bind(this);
        this.state = {
            pages: [],
            paginate: 0,
            currentPage: [],
            currentPageIndex: 0
        };
    }

    componentWillMount()
    {
        let self = this;
    }

    componentDidMount()
    {
    }

    search()
    {
        let self = this;
        let search = $('#usersInputSearch').val();

        if (search.length !== 0) {
            self.setState({
                list: []
            });

            swal({
                text: "Recuperando información, espere un momento.",
                buttons: false,
                closeOnClickOutside: false
            });

            axios.get('/api/crm/' + search)
                .then(response => {
                    swal.close();
                    let pages = response.data.pages;
                    let paginate = response.data.paginate;
                    let currentPage = pages[0];

                    self.setState({
                        pages: pages,
                        paginate: paginate,
                        currentPage: currentPage,
                        currentPageIndex: 0
                    });
                })
                .catch(error => {
                    swal({
                        title: "¡Oh no!",
                        text: "No se han obtenido resultados.",
                        icon: "warning",
                    });
                });
        } else {
            swal({
                text: "Por favor, introduce un criterio de búsqueda.",
                icon: "warning",
            });
        }
    }

    changePage(flag)
    {
        let self = this;
        if (flag === 1) {
            let nextPageIndex = this.state.currentPageIndex;
            nextPageIndex++;
            let pages = this.state.pages;

            self.setState({
                currentPage: pages[nextPageIndex],
                currentPageIndex: nextPageIndex
            });
        } else {
            let backPageIndex = this.state.currentPageIndex;
            backPageIndex--;
            let pages = this.state.pages;

            self.setState({
                currentPage: pages[backPageIndex],
                currentPageIndex: backPageIndex
            });
        }
    }

    renderResults(item)
    {
        return(
            <tr key={item.id}>
                <td>{item.created_at}</td>
                <td>{item.tdc}</td>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>{item.promo}</td>
                <td>{item.birthday}</td>
                <td>{item.month_promo}</td>
                <td>
                    <a href={'/crm/promo_users/' + item.id} className="btn btn-info">
                        <i className="fa fa-info-circle"></i> Detalles
                    </a>
                </td>
            </tr>
        );
    }

    render()
    {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <div className="row">
                                        <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
                                            <h3>Ingresa los datos de búsqueda</h3>
                                            <div className="input-group m-t-10">
                                                <input type="text" id="usersInputSearch" className="form-control"
                                                placeholder="Tarjeta, Folio, Nombre o Email"/>
                                                <span className="input-group-btn">
                                                    <button type="button" className="btn waves-effect waves-light btn-primary"
                                                            onClick={this.search}>
                                                        <i className={"fa fa-search"}></i> Buscar
                                                    </button>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {
                        this.state.currentPage.length !== 0 &&
                        <div className="row">
                            <div className="col-md-12">
                                <div className="panel panel-default">
                                    <div className="panel-body">
                                        <table className="table table-striped m-0">
                                            <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th className="col-md-2">Tarjeta/Folio</th>
                                                <th>Nombre</th>
                                                <th>Correo electrónico</th>
                                                <th>Promoción</th>
                                                <th>Fec. Nac.</th>
                                                <th>Mes Promo</th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.currentPage.map(this.renderResults)}
                                            </tbody>
                                        </table>
                                        <hr/>
                                        {
                                            this.state.paginate !== 1 &&
                                                <div className="row">
                                                    <div className="col-md-2">
                                                        <button className="btn btn-success pull-left"
                                                                disabled={this.state.currentPageIndex === 0}
                                                                onClick={this.changePage.bind(this, 0)}>
                                                            <i className="fa fa-arrow-left"></i> Anterior
                                                        </button>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="text-center">
                                                            Página {this.state.currentPageIndex + 1} de {this.state.paginate}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <button className="btn btn-success pull-right"
                                                                disabled={this.state.currentPageIndex === this.state.paginate - 1}
                                                                onClick={this.changePage.bind(this, 1)}>
                                                            <i className="fa fa-arrow-right"></i> Siguiente
                                                        </button>
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </div>
        );
    }
}

export default Crm;

if (document.getElementById('crm-component')) {
    ReactDOM.render(<Crm />, document.getElementById('crm-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/crm/Crm.jsx